import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import travel2 from "../assets/travel4.jpg";
import Footer from "../Components/Footer";
import ContactForm from "../Components/ContactForm";

const Contact = () => {
  return (
    <div>
      <Navbar />
      <Hero
        cName="hero-middle"
        heroImg={travel2}
        title="Contact"
        btnClass="hide"
      />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Contact;
